import React, { Fragment } from 'react'

const Dates = ({item, index,text}) => (
  <Fragment className="dates">
    <dt>{`${text} ${index+1}`}</dt>
    <dd>{item}</dd>
  </Fragment>
)

const Othersettings = ({data, pageJson, translations}) => (
  <div className="detail-container">
    <div className="detail-container__heading">{`4. ${translations(pageJson.pageHeading)}`}</div>
    <div className="detail-container__content">
    {data.notionalPooling.otherSettings !== undefined && Object.keys(data.notionalPooling.otherSettings).length !== 0 ?
      <dl className="detail-container__horizontal-row">
        <dt>{translations(pageJson.baseCurrency)}</dt>
        {
          data.notionalPooling.otherSettings.baseCurrency !== undefined && data.notionalPooling.otherSettings.baseCurrency.name !== ''
          ? <dd>{data.notionalPooling.otherSettings.baseCurrency.name}</dd>
          : <dd>&nbsp;</dd>
        }
        <dt>{translations(pageJson.interestPeriod)}</dt>
        {
          data.notionalPooling.otherSettings.frequencyInfo !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType !== undefined
          ? <dd>{data.notionalPooling.otherSettings.frequencyInfo.frequencyType.name}</dd>
          : <dd>&nbsp;</dd>
        }
        {
          data.notionalPooling.otherSettings.frequencyInfo !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType.name == 'Weekly'
          ? [
              <dt>{translations(pageJson.settlementDate)}</dt>,
              <dd>{data.notionalPooling.otherSettings.frequencyInfo.frequencyDetails.name}</dd>
            ]
          : null
        }

        {
          data.notionalPooling.otherSettings.frequencyInfo !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType.name === 'Quarterly'
          ? [
              <dt>{translations(pageJson.settlementDate)}</dt>,
              <dd>{data.notionalPooling.otherSettings.frequencyInfo.frequencyDetails.name}</dd>
            ]
          : null
        }
        {
          data.notionalPooling.otherSettings.frequencyInfo !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType.name === 'Monthly'
          ?
          data.notionalPooling.otherSettings.frequencyInfo !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType.name === 'Monthly' && data.notionalPooling.otherSettings.frequencyInfo.frequencyDetails !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyDetails.name !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyDetails.name === 'Specific day'
          ? [
              <dt>{translations(pageJson.settlementDate)}</dt>,
              <dd>{data.notionalPooling.otherSettings.frequencyInfo.frequencyDetails.name}</dd>,
              <dt>{'Choose Day'}</dt>,
              <dd>{data.notionalPooling.otherSettings.frequencyInfo.frequencyDetailValue.name}</dd>
            ]
          :
          [
            <dt>{translations(pageJson.settlementDate)}</dt>,
            <dd>{data.notionalPooling.otherSettings.frequencyInfo.frequencyDetails.name}</dd>
          ]
          : null
        }

        {
          data.notionalPooling.otherSettings.frequencyInfo !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType.name === 'Calender Date'
          ? data.notionalPooling.otherSettings.frequencyInfo.dates.filter(item => item !== '').map((item,i) => <Dates item={item} index={i} text={translations(pageJson.settlementDate)}/>)
          : null
        }
        {
          data.notionalPooling.otherSettings.frequencyInfo !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType !== undefined && data.notionalPooling.otherSettings.frequencyInfo.frequencyType.name === 'Annually'
          ? [
              <dt>{translations(pageJson.settlementDate)}</dt>,
              <dd>{data.notionalPooling.otherSettings.frequencyInfo.annualDate}</dd>
            ]
          : null
        }
        <dt>{translations(pageJson.grpLimit)}</dt>
        {
          data.notionalPooling.otherSettings !== undefined
          ? <dd>{data.notionalPooling.otherSettings.odLimit}</dd>
          : <dd>&nbsp;</dd>
        }
        <dt>{translations(pageJson.unauthorisedOd)}</dt>
        <dd>
        {
          data.notionalPooling.otherSettings.unauthorizedInterestTypeFloating !== undefined && data.notionalPooling.otherSettings.unauthorizedInterestTypeFloating === true
          ? translations(pageJson.floating)
          : translations(pageJson.fixed)
        }
        </dd>
        <dt>{translations(pageJson.baseRate)}</dt>
        {
          data.notionalPooling.otherSettings.unauthorisedOD !== undefined && 'baseRate' in data.notionalPooling.otherSettings.unauthorisedOD && data.notionalPooling.otherSettings.unauthorisedOD.baseRate !== ''
          ? <dd>{data.notionalPooling.otherSettings.unauthorisedOD.baseRate}</dd>
          : <dd>&nbsp;</dd>
        }
        <dt>{translations(pageJson.code)}</dt>
        {
          data.notionalPooling.otherSettings.unauthorisedOD !== undefined && 'baseRateCode' in data.notionalPooling.otherSettings.unauthorisedOD && data.notionalPooling.otherSettings.unauthorisedOD.baseRateCode !== ''
          ? <dd>{data.notionalPooling.otherSettings.unauthorisedOD.baseRateCode}</dd>
          : <dd>&nbsp;</dd>
        }
        <dt>{translations(pageJson.spread)}</dt>
        {
          data.notionalPooling.otherSettings.unauthorisedOD !== undefined && 'spread' in data.notionalPooling.otherSettings.unauthorisedOD && data.notionalPooling.otherSettings.unauthorisedOD.spread !== ''
          ? <dd>{data.notionalPooling.otherSettings.unauthorisedOD.spread}</dd>
          : <dd>&nbsp;</dd>
        }
        <dt>&nbsp;</dt>
        <dd>
        {
          data.notionalPooling.otherSettings.unauthorisedOD !== undefined && 'marginBaseRate' in data.notionalPooling.otherSettings.unauthorisedOD && data.notionalPooling.otherSettings.unauthorisedOD.marginBaseRate === true
          ? translations(pageJson.margin)
          : translations(pageJson.fixedValue)
        }</dd>
        <dt>{translations(pageJson.maxInterest)}</dt>
        {
          data.notionalPooling.otherSettings.unauthorisedOD !== undefined && 'maximumInterest' in data.notionalPooling.otherSettings.unauthorisedOD && data.notionalPooling.otherSettings.unauthorisedOD.maximumInterest !== ''
          ? <dd>{data.notionalPooling.otherSettings.unauthorisedOD.maximumInterest}</dd>
          : <dd>&nbsp;</dd>
        }
        <dt>{translations(pageJson.minInterest)}</dt>
        {
          data.notionalPooling.otherSettings.unauthorisedOD !== undefined && 'minimumInterest' in data.notionalPooling.otherSettings.unauthorisedOD && data.notionalPooling.otherSettings.unauthorisedOD.minimumInterest !== ''
          ? <dd>{data.notionalPooling.otherSettings.unauthorisedOD.minimumInterest}</dd>
          : <dd>&nbsp;</dd>
        }
      </dl>:null}
    </div>
  </div>
)
export default Othersettings



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/NPPreview/otherSetting.js